module.exports = __webpack_public_path__ + "grootstatic/media/banner-en.cbb32585.svg";